export const SET_PRACTICE_STEP = 'SET PRACTICE STEP';
export const SET_LEVELS_COMPLETED = 'MS SET LEVELS COMPLETED';
export const SET_LEVEL = 'MS SET LEVEL';
export const SET_START_LEVEL = 'MS SET START LEVEL';
export const SET_TIME_LEFT = 'SET TIME LEFT';
export const SET_SCORE = 'MS SET SCORE';
export const SET_INTRODUCED = 'MS SET INTRODUCED';
export const UPDATE_STATS = 'MS UPDATE STATS';
export const SET_OPTIONS = 'MS SET OPTIONS';
export const PAUSE = 'MS PAUSE';
export const LOADING_GAME = 'MS LOADING GAME';
export const SHOW_INTRO = 'MS SHOW INTRO';
export const SET_MODE = 'MS SET MODE';

export const setPracticeStep = practiceStep => ({ type: SET_PRACTICE_STEP, practiceStep });
export const setLevelsCompleted = levelsCompleted => ({ type: SET_LEVELS_COMPLETED, levelsCompleted });
export const setLevel = level => ({ type: SET_LEVEL, level });
export const setStartLevel = startLevel => ({ type: SET_START_LEVEL, startLevel });
export const setTimeLeft = timeLeft => ({ type: SET_TIME_LEFT, timeLeft });
export const setScore = (hits, misses, score) => ({ type: SET_SCORE, payload: { hits, misses, score } });
export const setIntroduced = introduced => ({ type: SET_INTRODUCED, introduced });
export const updateStats = (plays, aggScore, best) => ({ type: UPDATE_STATS, payload: { plays, aggScore, best } });
export const setOptions = options => ({ type: SET_OPTIONS, options });
export const pause = on => ({ type: PAUSE, on });
export const setLoadingGame = on => ({ type: LOADING_GAME, on });
export const showIntro = show => ({ type: SHOW_INTRO, show });
export const setMode = mode => ({ type: SET_MODE, mode });
